/**
 * /frontend/src/features/analytics/components/staffing/DemandForecastChart.js
 */

import React, { useMemo } from 'react';
import ChartContainer from '../shared/ChartContainer';
import ForecastLineChart from '../charts/ForecastLineChart';
import { CHART_COLORS } from '../../constants/chartColors';

/**
 * Demand forecast line chart.
 * @param {{data:Array<any>}} props
 * @returns {JSX.Element}
 */
const DemandForecastChart = ({ data }) => {
  const lines = useMemo(() => ([
    { key: 'predictedJoins', label: 'Forecast', color: CHART_COLORS.accent }
  ]), []);

  return (
    <ChartContainer title="Demand Forecast" subtitle="Predicted joins for upcoming period">
      <ForecastLineChart data={data} xKey="label" lines={lines} lowKey="confidenceLow" highKey="confidenceHigh" />
    </ChartContainer>
  );
};

export default DemandForecastChart;

